import { useMutation } from "@tanstack/react-query"
import moment from "moment"
import api from "../services/axios"
import useAuth from '../hooks/useAuth'
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { useEffect, useState } from "react"


const HeartButton = ({ isAlreadyLiked = false, onChange }) => {
  const [liked, setLiked] = useState(false);

  const toggleLike = () => {
    // Optional: add a tiny delay to allow previous animation to finish
    // or just toggle immediately:
    setLiked(!liked);
    onChange && onChange(!liked)
  };
  useEffect(() => {
   setLiked(isAlreadyLiked)
  }, [isAlreadyLiked])

  return (
    <button
      onClick={toggleLike}
      className={`EventLikeButton heart-button ${liked ? 'liked' : ''}`}
      aria-label={liked ? "Unlike" : "Like"}
    >
      <div className="heart-splash"></div> {/* This is the splash container */}
      <svg
        className="heart-icon"
        viewBox="0 0 24 24"
        fill={liked ? "red" : "none"}
        stroke={liked ? "red" : "currentColor"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    </button>
  );
};


export const DateTimeBadge = ({ className, datetime }) => {
   return (
      <div className={"DateTimeBadge " + className}>
         <h3 className="date-text">
            {moment(datetime).format("DD")} {moment(datetime).format("MMM")}
         </h3>
         <div className="date-month text-sm">
            {moment(datetime).format("YYYY")}
         </div>
      </div>
   )
}


function _isAlreadyLiked(user, eventId) {
   return user?.likes?.events?.find(ev => ev.id == eventId)
}

export const EventLikeButton = ({ event }) => {
   const navigate = useNavigate()
   const { isAuthenticated, user, token, refresh } = useAuth()
   const isAlreadyLiked = _isAlreadyLiked(user, event?._id)
   const { mutate, isPending } = useMutation({

      mutationFn: async (values = {}) => {
         console.log({ isAuthenticated, user, token }, token)
         // authenticate 1st
         if (!isAuthenticated) {
            navigate("/signin");
            return;
         }
         const url = isAlreadyLiked ? `api/user/dislikes/events/${event?._id}`: `api/user/likes/events/${event?._id}`
         const { data } = await api.post(url, values)
         return data
      },
      onSuccess(res) {
         if (res.ok) {
            toast.success(res.message || (isAlreadyLiked ? "Event unliked successfully" : "Event liked successfully"))
            refresh()
         }
      },
      onError(err) {

      }
   })
   return (
      <HeartButton isAlreadyLiked={isAlreadyLiked} onChange={() => mutate({})} />
   )
   if (isAlreadyLiked) {
      return (
         <>
            <button className="EventLikeButton" type="button" onClick={() => mutate({})} disabled={isPending}>
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red" className="size-6">
                  <path d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" />
               </svg>
            </button>
         </>
      )
   }
   return (
      <>
         <button className="EventLikeButton" type="button" onClick={() => mutate({})} disabled={isPending}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="size-6">
               <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
            </svg>
         </button>
      </>
   )
}

export const EventArtistsDetails = () => {
   return (
      <></>
   )
}
